// extracted by mini-css-extract-plugin
export var modalFooter = "_my-0";